import React, { useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import axios from 'axios';
import '../../scss/style/map.scss';
import { Link } from 'react-router-dom';
import ReactStars from 'react-rating-stars-component';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';

const Nearestplaces = () => {
  const [nearestPlaces, setNearestPlaces] = useState([]);
  const [placeImages, setPlaceImages] = useState([]);
  const [averageRatings, setAverageRatings] = useState({});

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYWxpYWEyMDAwIiwiYSI6ImNscWEwYzZsMjFsb3YybG52bmRxeXV5ajgifQ.2CaDyP4GCkdHyQrYi3LNpA';

    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/outdoors-v11',
      center: [0, 0],
      zoom: 1,
    });

    map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    const fetchData = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        const { latitude, longitude } = position.coords;

        const response = await axios.post('https://sydney-backend.vercel.app/api/v1/sites/near', {
          payload: {
            lat: latitude,
            long: longitude,
          },
        });

        setNearestPlaces(response.data.data);

        const imagePromises = response.data.data.map(async (place) => {
          try {
            const matchingPlace = await axios.get(`https://sydney-backend.vercel.app/api/v1/sites/${place.id}`);
            if (matchingPlace.data.images && matchingPlace.data.images.length > 0) {
              return { placeId: place.id, imageUrl: matchingPlace.data.images[0] };
            } else {
              return { placeId: place.id, imageUrl: null };
            }
          } catch (imageError) {
            console.error(`Error fetching image for place ${place.id}:`, imageError);
            return { placeId: place.id, imageUrl: null };
          }
        });

        const images = await Promise.all(imagePromises);
        setPlaceImages(images);

        const ratingPromises = response.data.data.map(async (place) => {
          try {
            const ratingResponse = await axios.get(`https://sydney-backend.vercel.app/api/v1/reviews/averageRate/${place.id}`);
            const avgRating = ratingResponse.data.data[0].average_rating;
            return { placeId: place.id, averageRating: avgRating };
          } catch (ratingError) {
            console.error(`Error fetching rating for place ${place.id}:`, ratingError);
            return { placeId: place.id, averageRating: 0 };
          }
        });

        const ratings = await Promise.all(ratingPromises);
        const ratingsMap = ratings.reduce((acc, { placeId, averageRating }) => {
          acc[placeId] = averageRating;
          return acc;
        }, {});
        setAverageRatings(ratingsMap);
        console.log(averageRatings)

        response.data.data.forEach((place) => {
          new mapboxgl.Marker({
            color: '#FF0000',
          })
            .setLngLat([place.long, place.lat])
            .setPopup(new mapboxgl.Popup().setHTML(`<h3>${place.name}</h3>`))
            .addTo(map);
        });
        map.setCenter([longitude, latitude]);
        map.setZoom(8);
        new mapboxgl.Marker({
          color: '#FA8B02',
        })
          .setLngLat([longitude, latitude])
          .setPopup(new mapboxgl.Popup().setHTML(`<h3>your location</h3>`))
          .addTo(map);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <NavBar />
      <div className='bigcontainerr'>
        <div className='nearplaces-holder'>
          <h2>Places nearest to you</h2>
          <div className='nearplaces'>
            {nearestPlaces && nearestPlaces.length > 0 ? (
              nearestPlaces.map((place) => {
                const image = placeImages.find((img) => img.placeId === place.id);
                const averageRating = averageRatings[place.id] || 0;
                return (
                  <div className='nearplacescard' key={place.id}>
                    {image && image.imageUrl && (
                      <div className='image-container'>
                        <img src={image.imageUrl} alt={place.name} />
                      </div>
                    )}
                    <div className='text-container'>
                      <h3>{place.name}</h3>
                      <div className='star-rating'>
                        <ReactStars
                          count={5}
                          value={averageRating}
                          size={24}
                          activeColor="#ffd700"
                          edit={false}
                        />
                      </div>
                      <p>{place.dist_meters !== undefined ? (place.dist_meters / 1000).toFixed(2) + ' km away' : 'N/A'}</p>
                      <Link to={`/${place.id}/${place.name.replace(/\s+/g, '')}`}>View</Link>
                    </div>
                  </div>
                );
              })
            ) : null}
          </div>
        </div>
        <div className='mapcontainer'>
          <div id='map' />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Nearestplaces;
